import LabourerForm from "./LabourerForm";

import { toApiDateTime } from "../utils/dateUtils";

const AddLabourerForm = ({ onSubmit, isLoading, onCloseClicked }) => {
  const handleSubmit = ({ fullName, email, dateOfBirth, onboardingDate, offboardingDate }) => {
    const payload = { fullName, email };

    if (dateOfBirth) payload.dateOfBirth = toApiDateTime(dateOfBirth);
    if (onboardingDate) payload.onboardingDate = toApiDateTime(onboardingDate);
    if (offboardingDate) payload.offboardingDate = toApiDateTime(offboardingDate);

    onSubmit(payload);
  };

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[600px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add Labourer</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <LabourerForm
        isLoading={isLoading}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddLabourerForm;
